import { render, staticRenderFns } from "./DetailTitle.vue?vue&type=template&id=62435400&"
import script from "./DetailTitle.vue?vue&type=script&lang=js&"
export * from "./DetailTitle.vue?vue&type=script&lang=js&"
import style0 from "./DetailTitle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports